<script setup lang="ts">
import PhIcon from '@/components/PhIcon.vue'
import LabelBase from '@/components/label/LabelBase.vue'
import type { SidebarMenuButton } from '@/types'
import { useRouter, useRoute } from 'vue-router'
import { computed } from 'vue'

const props = defineProps<{
  data: SidebarMenuButton
}>()

const route = useRoute()
const router = useRouter()

const active = computed(() => route.name === props.data.url)

const goToUrl = () => {
  router.push({
    name: props.data.url,
  })
}
</script>

<template>
  <div>
    <div
      @click="goToUrl"
      :class="
        active
          ? 'bg-blue-600/25 dark:bg-blue-300/25 text-blue-600 dark:text-blue-300'
          : 'hover:bg-stone-100 dark:hover:bg-stone-700'
      "
      class="flex px-4 py-2 gap-2 cursor-pointer rounded-xl transition-colors duration-150"
    >
      <ph-icon :name="data.icon"></ph-icon>
      <label-base class="self-center whitespace-nowrap" size="sm">{{ data.name }}</label-base>
    </div>
    <div v-if="data.component">
      <component :is="data.component"></component>
    </div>
  </div>
</template>

<style scoped></style>
